import { PeriscopeList } from '../../../general';
import { PeriscopeRelatedObjectsList } from '../../../general/related-objects';
import { useApiResource } from '@hooks';
import { EntityReference, PeriscopeRelatedObjects } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';

export interface EntityRelatedObjectsTabProps {
	index: number;
	sonarObjectId: number;
}

export const EntityRelatedObjectsTab: React.FC<EntityRelatedObjectsTabProps> = ({ index, sonarObjectId }) => {
	const uri = `/v2/salesforce/SfEntityDefinitions/${sonarObjectId}/related-objects`;
	const { resource, loading } = useApiResource<PeriscopeRelatedObjects>(uri);
	const refs = Object.values(resource ?? []);

	const renderRelatedObjects = useCallback(
		(entityReferences: EntityReference[]) =>
			<PeriscopeRelatedObjectsList
				parentIndex={ index }
				relatedObjects={ entityReferences } />
		,
		[ index ]
	);

	return <PeriscopeList
		list={ renderRelatedObjects }
		loading={ loading }
		results={ refs ?? [] } />;
};
